import http from '@/requests/http'
import utilityHelper from '@/helpers/utils'

class MyAccount {
  static findAll (params) {
    return http.post('my-account/index', params)
  }
  static async update (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('my-account/update', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static async updatePassword (data) {
    return http.post('my-account/change-password', data)
  }
}

export default MyAccount
